import React from 'react';

import { FormSection } from 'src/app/components/lib/form';
import { Input } from 'src/app/components/lib/input';
import { WizardCard } from 'src/app/components/lib/wizard/card';

import { useDiscountWizardStateContext } from '../../state';
import { OnlineDetailsStepActions } from '../../state/online-details';

import { ImageUpload } from './image-upload';
import { RankTooltip, RankTooltipVisual } from './styled';

export function DetailsCard() {
  const {
    onlineDetailsStepDispatch,
    onlineDetailsStepState: { description, onlineName, rank },
    detailsStepState: { availableOnline },
  } = useDiscountWizardStateContext();
  return (
    <WizardCard
      description='Define what your customers will see when they view this discount on your ecommerce menu.'
      title='Online details'
      titleSize={18}
    >
      <FormSection>
        <Input
          label='Online name:'
          labelPlacement='top'
          required={availableOnline}
          value={onlineName}
          onChange={({ target }) =>
            onlineDetailsStepDispatch({ type: OnlineDetailsStepActions.SET_ONLINE_NAME, payload: target.value })
          }
        />
        <Input
          label='Description:'
          labelPlacement='top'
          maxlength={450}
          multiline
          rows={8}
          showCharacterCount
          value={description}
          onChange={({ target }) =>
            onlineDetailsStepDispatch({ type: OnlineDetailsStepActions.SET_DESCRIPTION, payload: target.value })
          }
        />
        <Input
          label='Display order priority:'
          labelPlacement='top'
          required={availableOnline}
          tooltip={
            <RankTooltip>
              Display order priority affects the placement of this discount on the specials page of your ecommerce menu.
              <RankTooltipVisual />
            </RankTooltip>
          }
          type='number'
          useV2Tooltip
          value={rank}
          onChange={({ target }) =>
            onlineDetailsStepDispatch({
              type: OnlineDetailsStepActions.SET_RANK,
              payload: target.value === '' ? '' : Number(target.value),
            })
          }
        />
        <ImageUpload />
      </FormSection>
    </WizardCard>
  );
}
